import { observable, action } from 'mobx';
import { app } from '../App';

export enum ChangePasswordStatus {
    Default,
    Updating,
    Success,
    ErrorAllFieldsAreRequired,
    ErrorNewPasswordsDoNotMatch,
    ErrorOther
}

export class ChangePassword {
    @observable public showChangePasswordModal: boolean = false;

    @observable public changePasswordStatus: ChangePasswordStatus = ChangePasswordStatus.Default;

    @observable public passwords: { currentPassword: string; newPassword: string; newPasswordRepeat: string; } = {
        currentPassword: '',
        newPassword: '',
        newPasswordRepeat: ''
    };

    @action public updatePassword = (value: string, type: 'currentPassword' | 'newPassword' | 'newPasswordRepeat') => {
        this.passwords[type] = value;
    }

    @action public clearPasswords = () => {
        this.passwords.currentPassword = '';
        this.passwords.newPassword = '';
        this.passwords.newPasswordRepeat = '';
    }

    @action public resetStatus = () => {
        this.changePasswordStatus = ChangePasswordStatus.Default;
    }

    @action public openChangePasswordModal = () => {
        this.resetStatus();
        this.clearPasswords();
        this.showChangePasswordModal = true;
    }

    @action public hideChangePasswordModal = () => {
        this.showChangePasswordModal = false;
        setTimeout(() => {
            this.clearPasswords();
            this.resetStatus();
        }, 1000);
    }

    @action public submitPasswordChange = async (userId: number) => {
        const { currentPassword, newPassword, newPasswordRepeat } = this.passwords;

        try {
            // Start updating
            this.changePasswordStatus = ChangePasswordStatus.Updating;

            // Show error if any of fields is empty
            if (currentPassword === '' || newPassword === '' || newPasswordRepeat === '') {
                this.changePasswordStatus = ChangePasswordStatus.ErrorAllFieldsAreRequired;
                return false;
            }

            // Show error if new password fields do not match
            if (newPassword !== newPasswordRepeat) {
                this.passwords.newPassword = '';
                this.passwords.newPasswordRepeat = '';
                this.changePasswordStatus = ChangePasswordStatus.ErrorNewPasswordsDoNotMatch;
                return false;
            }

            // Patch user password
            const service = await app.service('users');
            const modifiedUser = await service.patch(userId, {
                currentPassword: this.passwords.currentPassword,
                newPassword: this.passwords.newPassword,
                confirmPassword: this.passwords.newPasswordRepeat
            });

            // Show success
            this.changePasswordStatus = ChangePasswordStatus.Success;
            this.clearPasswords();

            setTimeout(() => {
                if (this.changePasswordStatus === ChangePasswordStatus.Success) {
                    this.changePasswordStatus = ChangePasswordStatus.Default;
                }
            }, 1000 * 5);

            return true;
        } catch (error) {
            this.changePasswordStatus = ChangePasswordStatus.ErrorOther;
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/ChangePassword.ts